import { reactive, readonly } from 'vue';

// One confirm dialog for the whole app (mounted in the shell), instead of a
// delete dialog per page. `await confirm({...})` resolves true or false.
const state = reactive({
  open: false,
  title: '',
  description: '',
  confirmText: 'Continue',
  cancelText: 'Cancel',
  destructive: false,
});
let resolver = null;

function settle(result) {
  state.open = false;
  resolver?.(result);
  resolver = null;
}

export function useConfirm() {
  function confirm(options = {}) {
    // A second request while one is open cancels the first.
    if (resolver) settle(false);
    Object.assign(state, {
      title: 'Are you sure?',
      description: '',
      confirmText: 'Continue',
      cancelText: 'Cancel',
      destructive: false,
      ...options,
      open: true,
    });
    return new Promise((resolve) => {
      resolver = resolve;
    });
  }

  return {
    confirm,
    state: readonly(state),
    accept: () => settle(true),
    cancel: () => settle(false),
  };
}
